{
  "hero": {
    "title": "資料保存政策",
    "description": "說明不同類型資料的保存原則、作品權利，以及帳號與個資的刪除申請方式。本頁只描述平台目前實際採行的原則，不承諾尚未核准的保存期限。"
  },
  "quickNav": {
    "label": "頁內導覽",
    "retention": "保存原則",
    "ownership": "作品權利",
    "deletion": "帳號與資料刪除",
    "related": "相關頁面"
  },
  "retention": {
    "heading": "保存原則",
    "description": "各類資料的保存原則如下，多數資料類型之具體保存期限（例如以年為單位的法定保存年限）目前尚未由主辦單位另行核准公告，因此本頁不列出這些類型未經核准的天數或年限；若特定類型已有核准之保存期限（詳見下方），則會明確標示：",
    "categories": {
      "account": {
        "title": "帳號資料",
        "description": "於帳號有效期間內保存；使用者可申請帳號相關個資的刪除或匿名化，惟已產生的競賽歷史紀錄可能因下方稽核需求而部分保留。"
      },
      "submission": {
        "title": "競賽作品與報名資料",
        "description": "正式提交的作品與報名紀錄，在該場競賽仍具有效力（含賽後成果展示、爭議處理與稽核需求）期間予以保留；是否移除由該場競賽主辦方依規則決定。"
      },
      "eligibilityProof": {
        "title": "在學/資格證明檔案",
        "description": "您上傳之在學／資格證明原始檔案，將於所屬競賽結束後 365 天自動且永久從系統刪除。檔案刪除後，審核結果（核准／駁回、審核人、時間）與相關稽核紀錄仍會保留。"
      },
      "audit": {
        "title": "稽核紀錄",
        "description": "成績、權限與重要狀態異動的稽核紀錄為 Append-only（只增不改不刪），以支援事後查核與爭議處理，不因使用者提出一般刪除申請而自動移除。"
      },
      "backup": {
        "title": "備份資料",
        "description": "系統備份用於災難復原與服務可靠性，備份中的資料會隨正常的備份週期輪替，不做為長期封存使用。"
      },
      "event": {
        "title": "活動服務資料",
        "description": "活動的乘車聯絡資料（含加密的行動電話）、餐飲與宴會回覆、飲食備註、提醒同意與寄送紀錄，於活動結束後預設 30 天自動刪除（已核准的保存期限）；接駁預約與驗票紀錄、稽核紀錄依稽核需求保留。"
      }
    }
  },
  "ownership": {
    "heading": "作品權利",
    "items": {
      "copyright": "參賽作品的著作權原則上仍屬於參賽者（或依各校/單位規定歸屬指導教師/學校），平台本身不主張作品的著作權。",
      "display": "主辦單位是否可公開展示作品內容，依各場競賽公告的規則為準；若該場競賽提供賽後成果展示（Showcase），是否收錄個別作品採 opt-in（需參賽者同意）原則，而非預設公開。",
      "license": "参賽者提交作品時，即同意平台與主辦方為執行評審、成績計算與（若參賽者同意）成果展示等目的，得以必要方式存取、複製與呈現該作品內容，惟不構成著作權移轉。"
    }
  },
  "deletion": {
    "heading": "帳號與資料刪除",
    "description": "帳號停權（Suspend）不等於完成個資刪除，停權只是暫時關閉登入能力，資料本身並未移除。您可以在登入後，於「帳號與安全」頁面自行提出永久刪除帳號的申請；申請會先由平台管理員審核後才會生效，核准前您可隨時自行取消申請。核准後會區分：",
    "exportNote": "您也可以在同一個「帳號與安全」頁面，下載一份與您帳號相關之個人資料 JSON 匯出檔（個人資料、您可見的作品與評分、近期帳號相關稽核紀錄），不需要提出刪除申請即可使用此功能。",
    "categories": {
      "deletable": {
        "title": "可直接刪除的個資",
        "description": "登入憑證（密碼／SSO 連結、有效 session）與已上傳之在學證明檔案，於核准後立即刪除。"
      },
      "anonymizable": {
        "title": "需匿名化/去識別化保留的資料",
        "description": "您的帳號基本資料（顯示名稱、Email、頭像、單位顯示名稱）會被去識別化而非刪除，以維持您所連結之歷史作品、評分與競賽結果資料完整性；去識別化後您將無法再從中被辨識。評審邀請與隊伍 Email 邀請上記錄的您的 Email 也會一併去識別化，評審邀請上選填的婉拒原因會被清除，尚未回覆的評審邀請會被取消。"
      },
      "retained": {
        "title": "因稽核或競賽正式紀錄需求必須保留的資料",
        "description": "例如已發布的競賽結果與對應的稽核紀錄，基於歷史完整性與爭議處理需求，不會因單一使用者的刪除申請而被移除或竄改。稽核紀錄在事件發生當時記載的內容（例如邀請對象的 Email）屬於只增不改，不會被改寫。"
      }
    },
    "note": "申請一經核准，即會立即完成上述匿名化與刪除，不會另外排程延後處理。若申請被拒絕，帳號不受影響，您之後仍可再次提出申請。"
  },
  "related": {
    "heading": "相關頁面",
    "privacy": "隱私權說明（蒐集哪些資料、為何蒐集、誰可以存取）",
    "terms": "使用條款",
    "trust": "Trust Center",
    "contact": "若您的問題不在上述自助服務範圍內，請寄信至"
  }
}
